import React from "react";
import "../styles/components/Logo.css";
import logoImage from "../images/Logo_ClinicStaffing.jpeg";

const Logo = () => {
  return (
    <div className="logo" aria-label="EzclinicStaffing">
      <div className="row-container">
        <img
          className="logo-image"
          src={logoImage}
          alt="EzclinicStaffing mark"
          loading="lazy"
          decoding="async"
        />

        <div className="brand-type">
          <div className="logo-text">
            <span className="light-blue">Ezclinic</span>
            <span className="dark-blue">Staffing</span>
          </div>

          <div className="text-below">CHECK YOUR PRACTICE PULSE</div>
        </div>
      </div>
    </div>
  );
};

export default Logo;
